import { useTranslation } from 'react-i18next';
import { useMedia } from '../../../hooks/useMediaQuery';

export function FooterBottom({ cookieStatement, copyrightKey }) {
    const { t } = useTranslation(['reportFooter']);
    const { isSmallDevice, isExtraSmallDevice } = useMedia();

    const year = new Date().getFullYear();
    const isCompact = isSmallDevice || isExtraSmallDevice;

    return (
        <div
            style={{
                marginTop: 48,
                paddingTop: 32,
                borderTop: '1px solid #e5e7eb',
                display: 'flex',
                flexDirection: isCompact ? 'column' : 'row',
                justifyContent: 'space-between',
                alignItems: isCompact ? 'flex-start' : 'center',
                gap: 16,
            }}
        >
            <p style={{ color: '#4b5563', fontSize: 14, margin: 0 }}>{t(copyrightKey, { year })}</p>
            <a href={cookieStatement.href} style={{ color: '#4b5563', fontSize: 14, textDecoration: 'none' }}>
                {cookieStatement.label}
            </a>
        </div>
    );
}
